import React from 'react';

import styles from './styles';

const {
    FooterContainer,
    FooterWrapper,
    FooterBigText,
    FooterText,
    FooterPart,
    RedLink,
    RedLinkUnderlined,
} = styles;

export default ({ status }) => (
    <FooterContainer status>
        <FooterWrapper>
            <FooterPart>
                <FooterText>
                    <RedLink
                        href="https://www.toyota.ru/finance-insurance/toyota-fs/"
                        target="__blank"
                    >
                        АО «Тойота Банк»
                    </RedLink> © {new Date().getFullYear().toString()}
                </FooterText>
                <FooterText>Лицензия Банка России №3470 от 22.07.2015 г.</FooterText>
            </FooterPart>
            <FooterPart>
                <FooterBigText>+8 (800) 350-38-83</FooterBigText>
                <FooterText>Круглосуточно, без выходных</FooterText>
                <FooterText>
                    <RedLinkUnderlined href="mailto:Booking@toyota-fs.com" target="__blank">
                        booking@toyota-fs.com
                    </RedLinkUnderlined>
                </FooterText>
            </FooterPart>
        </FooterWrapper>
    </FooterContainer>
);
